import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import { isEmpty, map } from "lodash";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import notes from "../../assets/images/rsicons/notes.png"
import phonelog from "../../assets/images/rsicons/phone-log.png"
import emaillog from "../../assets/images/rsicons/email-log.png"
import prefrence from "../../assets/images/rsicons/prefrence.png"
import {
  getContactDetail, getAllContactActivityTab,
  getCampaignEmailList,
  getCampContactList,
addCampaignEmailList, getEmailListTarget
} from "../../store/actions"
import Moment from 'react-moment';
import "react-rangeslider/lib/index.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Swal from 'sweetalert2'
import axios from 'axios'
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  Collapse,
  FormGroup,
  Label,
  Button,
  Nav,
  Alert,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  InputGroup,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Input,
} from "reactstrap"

import classnames from "classnames"
import "flatpickr/dist/themes/material_blue.css"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ContactEdit from "./forms/contact-edit";
import ContactDetailMenu from "./menu/detail-menu"
import ContactData from "./forms/contact-data";
import AppointmentLog from "./tab-comp/AppointmentLog";
import LeadNote from "./tab-comp/LeadNote";
import EmaillLog from "./tab-comp/EmaillLog";
import CallLog from "./tab-comp/CallLog";
import { API_URL } from "helpers/app_url";
import LeadMessage from "./tab-comp/LeadMessage";
import FollowLead from "./tab-comp/FollowLead";
import SmsLog from "./tab-comp/SmsLog";
import moment from "moment/moment";
import RsAdNew from "components/buttons/Adnew";
import SaveButton from "components/buttons/save";
import SafeHTML from "components/buttons/SafeHTML";
import ComposeContactMail from "components/dropdowns/ComposeEmailContact";
import SafeField from "helpers/SafeField";
import EmailActivityList from "components/dropdowns/EmailExpand";

class ContactDetail extends Component {
  constructor(props) {
    super(props)
    this.autocomplete = null,
      this.state = {
        col9: false,
        col10: false,
        col11: false,
        col12: true,
        col15: false,
        selectedGroup: null,
        activeTab: "1",
        verticalActiveTab: "1",
        selectedValue: '',
        value: 0,
        viewmodal: false,
        modal: false,
        titles: [],
        statuses: [],
        ccTab: "1",
        agentData:'',
         currentPage: 1,
        totalPages: 1,
        totalEmails:0,
        selectedEmails: [],
        showCompose: false,
      }

    this.t_col9 = this.t_col9.bind(this)
    this.t_col10 = this.t_col10.bind(this)
    this.t_col11 = this.t_col11.bind(this)
    this.t_col12 = this.t_col12.bind(this)
    this.t_col15 = this.t_col15.bind(this)
    this.toggle = this.toggle.bind(this);
this.toggleAddCollection = this.toggleAddCollection.bind(this);
this.handleProTypeSubmit = this.handleProTypeSubmit.bind(this);

  }
 toggleAddCollection() {
    this.setState({ isAddCollection: !this.state.isAddCollection });
  }
   handleProTypeSubmit(value) {
      const payload = {
          agentId: parseInt(value.agentId),
          emailListTypeId:parseInt(value.emailListTypeId),
          campaignEmailListName:value.campaignEmailListName,
          emailListTargetId:parseInt(value.emailListTargetId),
          campaignEmailListDesc:value.campaignEmailListDesc,
          isActive:true
      }
      this.props.addCampaignEmailList(payload, (status) => {
        if (status) {
          this.toggleAddCollection();
        }
      });
    }
  cctoggle(tab) {
    if (this.state.ccTab !== tab) {
      this.setState({
        ccTab: tab,
      });
    }
  }
 handleCheckboxChange = (emailId) => {
    this.setState((prevState) => {
      const selectedEmails = [...prevState.selectedEmails];
      if (selectedEmails.includes(emailId)) {
        selectedEmails.splice(selectedEmails.indexOf(emailId), 1);
      } else {
        selectedEmails.push(emailId);
      }
      return { selectedEmails };
    });
  };
    handleDelete = async () => {
      const { selectedEmails } = this.state;
    
      if (selectedEmails.length === 0) {
        Swal.fire({
          title: 'No emails selected',
          text: 'Please select emails to delete.',
          icon: 'warning',
          confirmButtonText: 'OK',
        });
        return;
      }
      
     
      //const confirmed = window.confirm("Are you sure you want to delete the selected emails?");
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this action!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
      });
      if (result.isConfirmed) {
        try {
          const obj = JSON.parse(localStorage.getItem("authUser"));
          const token = obj?.resultData?.bearerToken;
          const headers = {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          };
          for (let emailId of selectedEmails) {
            const url = `${API_URL}Gmail/DeleteGoogleEmail/${this.state?.agentData?.agentId}/${emailId}/1`;
            await axios.get(url, { headers });
            this.setState((prevState) => {
              const updatedMails = prevState.inboxMails.filter(
                (inbox) => inbox.messageID !== emailId
              );
              return { inboxMails: updatedMails };
            });
          }
          this.setState({ selectedEmails: [] });
    
        } catch (error) {
          console.error("Error deleting emails", error);
          alert("An error occurred while deleting emails.");
        }
      }
    };
  componentDidMount() {
    const { match: { params }, onGetContactDetail, onGetAllContactAct, onGetCampaignEmailList, onGetCampContactList, onGetEmailListTarget } = this.props;
    if (params && params.id) {
      onGetContactDetail(params.contactid);
      onGetAllContactAct(params.id);
      onGetCampaignEmailList(localStorage.getItem('userId')),
      onGetEmailListTarget(localStorage.getItem('userId'));
      onGetCampContactList(localStorage.getItem('userId'), params.id);
      this.setState({ Id: params.id });
    } else {
      onGetContactDetail(2);
    }

     if (!this.state.agentData) {
           const obj = JSON.parse(localStorage.getItem("authUser"));
           const token = obj?.resultData?.bearerToken;
           const userId = localStorage.getItem("userId");
           
           this.setState({ isLoading: true });
           axios.get(`${API_URL}Agent/${userId}`, {
             headers: { Authorization: `Bearer ${token}` }
           })
           .then(res => {
             const agentData = res.data;
             this.setState({ agentData });
           })
           .catch(error => {
             console.error('Error fetching agent data:', error);
           });
          }
  }
  fetchInboxMails(agentId, email,page) {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
  
      axios.get(`${API_URL}Gmail/GetMailFromByFromEmailPagination/${agentId}/${email}/${page}/20/false/false`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(secondResponse => {
        
        
        this.setState({
          inboxMails: secondResponse.data.items, 
          totalPages: secondResponse.data.totalPages || 1, 
          isLoading: false,
          
        totalEmails:secondResponse.data.totalPages 
        });
      })
      .catch(error => {
        console.error('Error fetching data from second API:', error);
        this.setState({ isLoading: false });
      });
    }
  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      })
    }
  }
  handleSelectGroup = selectedGroup => {
    this.setState({ selectedGroup })
  }
  t_col9() {
    this.setState({
      col9: !this.state.col9,
      col10: false,
      col11: false,
      col12: false,
      col15: false
    })
  }

  t_col10() {
    this.setState({
      col10: !this.state.col10,
      col9: false,
      col11: false,
      col12: false,
      col15: false
    })
  }

  t_col11() {
    this.setState({
      col11: !this.state.col11,
      col9: false,
      col10: false,
      col12: false,
      col15: false
    })
  }
  t_col12() {
    this.setState({
      col12: !this.state.col12,
      col11: false,
      col9: false,
      col10: false,
      col15: false
    })
  }
  t_col15() {
    this.setState({
      col15: !this.state.col15,
      col11: false,
      col9: false,
      col10: false,
      col12: false
    })
  }
  render() {
    const { contactDetail, allactivities, campaignemaillists, camplists, onGetCampContactList, emaillisttargets, userdetail, isResponsive } = this.props;
    const allLocal = localStorage.getItem('localData')
    const localization = JSON.parse(allLocal);
    const { inboxMails, isLoading, currentPage, totalPages} = this.state;
    const { selectedEmails, showCompose } = this.state;
    return (
      <React.Fragment>

        <div className="page-content project-page-content">
          <MetaTags>
            <title>Contact Detail | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0">
            <ToastContainer autoClose={2000} />
            <Row>
              <Col sm='3'>
                 {isResponsive && (
                                <Row className="project-header">
                                <Col sm='8'>
                                  <Breadcrumbs
                      title={this.props.t("Contact")}
                      breadcrumbItem={this.props.t("Contact Detail")}
                    />
                                
                                  </Col>
                                  <Col sm='4'>
                                      <h2>{contactDetail.firstName + " " + contactDetail.lastName}</h2>
                                  </Col>
                                  </Row>
                                )}
                <ContactData contactDetail={contactDetail} userdetail={userdetail} isResponsive={isResponsive} />
              </Col>
              <Col sm='9'>
              {!isResponsive &&(
                  <Row className="project-header">
                  <Col sm='8'>
                    <Breadcrumbs
                      title={this.props.t("Contact")}
                      breadcrumbItem={this.props.t("Contact Detail")}
                    />
                    {/* <Link to="/all-contacts" className="mb-4 text-black" ><div className="mb-2"><img src={backIcon}  width='16px' className="mdi mdi-home-import-outline ms-1"/> {" "}Back to Contacts </div></Link> */}
                  </Col>
                  <Col sm='4'>
                    <h2>{contactDetail.firstName + " " + contactDetail.lastName}</h2>
                  </Col>
                </Row>
              )}
                
                <ContactDetailMenu isResponsive={isResponsive} />
                <Row>
                  <Col xl="12">
                  {isResponsive ? (
                   <Card>
                    <CardBody>
                      <h6>Select</h6>
                       <select
                      className="form-select mb-3"
                      value={this.state.activeTab}
                      onChange={(e) => {
                        const value = e.target.value;
                        this.toggle(value);

                        // Trigger tab-specific actions (same as NavLink onClick)
                        switch (value) {
                          case "1":
                            this.props.onGetAllContactAct(this.state.Id);
                            break;
                          case "16":
                            this.fetchInboxMails(this.state.agentData?.agentId, contactDetail.email, 1);
                            break;
                        }
                      }}
                    >
                      <option value="1">{this.props.t("All Activities")}</option>
                      <option value="16">{this.props.t("Inbox")}</option>
                      {userdetail?.agentTimeZone?.isTwilioIntegrationEnabled && (
                        <option value="13">{this.props.t("Message")}</option>
                      )}
                      <option value="3">{this.props.t("Notes")}</option>
                      <option value="14">{this.props.t("Follow-ups")}</option>
                      <option value="15">{this.props.t("Logs")}</option>
                      <option value="9">{this.props.t("Interested In")}</option>
                      <option value="11">{this.props.t("Collections")}</option>
                    </select>
                    </CardBody>
                   </Card>
                   
                  ):(
                      <Nav
                      tabs
                      className="lead-tab mt-10 mb-10"
                    >
                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: this.state.activeTab === "1",
                          })}
                          onClick={() => {
                            this.toggle("1");
                            this.props.onGetAllContactAct(this.state.Id);
                          }}
                        >
                          <span className="">{this.props.t("All Activities")}</span>
                        </NavLink>
                      </NavItem>
                       <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: this.state.activeTab === "16",
                          })}
                          onClick={() => {
                            this.toggle("16");
                             this.fetchInboxMails(this.state.agentData?.agentId, contactDetail.email, 1);
                          }}
                        >
                          <span className="">{this.props.t("Inbox")}</span>
                        </NavLink>
                      </NavItem>
                      {userdetail?.agentTimeZone?.isTwilioIntegrationEnabled && (
                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: this.state.activeTab === "13",
                          })}
                          onClick={() => {
                            this.toggle("13")
                          }}
                        >

                          <span className="">{this.props.t("Message")}</span>
                        </NavLink>
                      </NavItem>
                      )}
                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: this.state.activeTab === "3",
                          })}
                          onClick={() => {
                            this.toggle("3")
                          }}
                        >

                          <span className="">{this.props.t("Notes")}</span>
                        </NavLink>
                      </NavItem>

                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: this.state.activeTab === "14",
                          })}
                          onClick={() => {
                            this.toggle("14");
                          }}
                        >
                          <span className="">
                            {this.props.t("Follow-ups")}
                          </span>
                        </NavLink>
                      </NavItem>

                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: this.state.activeTab === "15",
                          })}
                          onClick={() => {
                            this.toggle("15");
                          }}
                        >
                          <span className="k">
                            {this.props.t("Logs")}
                          </span>
                        </NavLink>
                      </NavItem>

{/*                       <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: this.state.activeTab === "6",
                          })}
                          onClick={() => {
                            this.toggle("6")
                          }}
                        >

                          <span className="">{this.props.t("Email Logs")}</span>
                        </NavLink>
                      </NavItem>


                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: this.state.activeTab === "5",
                          })}
                          onClick={() => {
                            this.toggle("5")
                          }}
                        >

                          <span className="k">{this.props.t("Call Logs")}</span>
                        </NavLink>
                      </NavItem>
 */}

                      {/* <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: this.state.activeTab === "7",
                          })}
                          onClick={() => {
                            this.toggle("7")
                          }}
                        >

                          <span className="">{this.props.t("Referrals")}</span>
                        </NavLink>
                      </NavItem> */}

                      {/* <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: this.state.activeTab === "8",
                          })}
                          onClick={() => {
                            this.toggle("8")
                          }}
                        >

                          <span className="">{this.props.t("Transactions")}</span>
                        </NavLink>
                      </NavItem> */}

                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: this.state.activeTab === "9",
                          })}
                          onClick={() => {
                            this.toggle("9")
                          }}
                        >

                          <span className="">{this.props.t("Interested In")}</span>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: this.state.activeTab === "11",
                          })}
                          onClick={() => {
                            this.toggle("11")
                          }}
                        >

                          <span className="">{this.props.t("Collections")}</span>
                        </NavLink>
                      </NavItem>


                    </Nav>
                  )}
                  
                    <Card>
                      <TabContent activeTab={this.state.activeTab} className="p-3 text-muted">
                        <TabPane tabId="1">
                          <div className="mb-5 h4 card-title">All Activities</div>
                           {allactivities && allactivities.length > 0 ? (
                          <ul className="verti-timeline list-unstyled">

                            {map(allactivities, (allactivity, allactkey) => (

                              <li className="event-list eventlist" key={"_allact_" + allactkey}>
                                <div className="event-timeline-dot">
                                  {(() => {
                                    if (allactivity.activitySubType == 8 || allactivity.activitySubType == 9 || allactivity.activitySubType == 7) {
                                      return (
                                        <>
                                          <img src={emaillog} />
                                        </>
                                      )
                                    } else if (allactivity.activitySubType == 3 || allactivity.activitySubType == 4 || allactivity.activitySubType == 5) {
                                      return (
                                        <>
                                          <img src={phonelog} />
                                        </>
                                      )
                                    } else {
                                      return (
                                        <>
                                          <img src={notes} />
                                        </>
                                      )

                                    }
                                  })()}
                                </div>
                                 <div className="d-flex">
                                <div className="flex-shrink-0 me-3">
                                  <h5 className="font-size-14"> Date : {" "}
                                    <Moment format="D MMM YY">
                                      {allactivity.addedDate}
                                    </Moment>
                                  </h5>
                                  <h5 className="font-size-14"> {
                                      localization[
                                        "ActivitySubType_" +
                                          allactivity.activityType +
                                          "_" +
                                          allactivity.activitySubType
                                      ]
                                    }  {allactivity.activityRefStartDate && (
  <>
    : <Moment format="D MMM YY">{allactivity.activityRefStartDate}</Moment>
  </>
)} </h5>
                                </div>
                              
                              </div>
                              <div className="exNote">
                                {allactivity.activityRemarks}
                              </div>
                              </li>
                            ))}

                          </ul>
                           ) : (
                          <div className="text-muted text-center py-3">No activity recorded as yet.</div>
                        )}
                        </TabPane>
                        <TabPane tabId="2">
                          <AppointmentLog contactDetail={contactDetail} />
                        </TabPane>
                        {userdetail?.agentTimeZone?.isTwilioIntegrationEnabled && (
                        <TabPane tabId="13">
                          <LeadMessage />
                        </TabPane>
                        )}
                        <TabPane tabId="3">
                          <LeadNote contactDetail={contactDetail} />
                        </TabPane>

                        <TabPane tabId="14">
                          <FollowLead contactDetail={contactDetail} />
                        </TabPane>

                        <TabPane tabId="15">
                          <Nav
                            tabs
                            className="lead-tab mt-10 mb-10 text-center"
                          >


                            <NavItem>
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                  active: this.state.ccTab === "1",
                                })}
                                onClick={() => {
                                  this.cctoggle("1");
                                }}
                              >
                                <span className="k">
                                  {this.props.t("Call Log")}
                                </span>
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                  active: this.state.ccTab === "2",
                                })}
                                onClick={() => {
                                  this.cctoggle("2");
                                }}
                              >
                                <span className="k">
                                  {this.props.t("Email Log")}
                                </span>
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                  active: this.state.ccTab === "3",
                                })}
                                onClick={() => {
                                  this.cctoggle("3");
                                }}
                              >
                                <span className="k">
                                  {this.props.t("SMS Log")}
                                </span>
                              </NavLink>
                            </NavItem>


                          </Nav>
                          <TabContent
                            activeTab={this.state.ccTab}
                            className="p-3 text-muted"
                          >
                            <TabPane tabId="1">
                              <CallLog  contactDetail={contactDetail} />
                            </TabPane>
                            <TabPane tabId="2">
                              <EmaillLog  contactDetail={contactDetail} />
                            </TabPane>
                            <TabPane tabId="3">
                              <SmsLog />
                            </TabPane>
                          </TabContent>
                        </TabPane>

                        <TabPane tabId="16">
                                  <button 
      className="btn btn-light same-size-btn"
      //onClick={this.togglemodal}
       onClick={() => this.setState({ showCompose: true })}
    >
      <i className="bx bx-envelope"></i> Compose
    </button>
                           {/* <div className="btn-group me-2 mb-2 mb-sm-0">
                                                                    
                                                                              {selectedEmails.length > 0 && (
                                                                        <Button type="button" color="primary" onClick={this.handleDelete}>
                                                                          <i className="far fa-trash-alt" />
                                                                        </Button>
                                                                      )}
                                                                    </div>
                              <ul className="message-list">
                                    {map(inboxMails, (inbox, key) => {
                                      const createdOnDate = moment(inbox.createdOn);
                                      const isToday = createdOnDate.isSame(moment(), 'day');
                                      
                                      return (
                                        <li key={key}
                                          style={
                                            Number(inbox.customEmailTemplateId) > 0 
                                              ? { backgroundColor: "lavender", color: "black" } 
                                              : { backgroundColor: "white", color: "black" }  
          
                                          }>
                                          <div className="col-mail col-mail-1">
                                            <div className="checkbox-wrapper-mail">
                                              <Input type="checkbox" id={inbox.messageID}
                                                onChange={() => this.handleCheckboxChange(inbox.messageID)}
                                                checked={selectedEmails.includes(inbox.messageID)}
                                              />
          
                                              <Label htmlFor={inbox.messageID} className="toggle" />
                                            </div>
                                            <Link to={`/email-read/${inbox.emailDetailId}`} className={`title ${inbox.customEmailTemplateId == 0 ? 'has-no-template' : ''}`}>
                                              {inbox.from}
                                            </Link>
                                            {Number(inbox.customEmailTemplateId) > 0 && (
                                              <Link className="bg-warning badge  badge-assign me-2 text-white" to={`/email-assign/${inbox.emailDetailId}`}>
                                                Assign
                                              </Link>
                                            )}
                                          </div>
                                        <div className={`col-mail col-mail-2 ${inbox.customEmailTemplateId == 0 ? 'has-no-mail' : ''}`}>
                                             <SafeHTML html={inbox.subject} />
                                           
                                            <div className="date">
                                              {isToday
                                                ? createdOnDate.format('h:mm A')
                                                : createdOnDate.format('MMM DD')}
          
                                            </div>
                                          </div>
                                        </li>
                                      );
                                    })}
                              </ul> */}

                           <EmailActivityList inboxMails={inboxMails} lead={contactDetail} agentData={userdetail} />

                        </TabPane>

                       




                        <TabPane tabId="7">
                          <div className="mb-5 h4 card-title">Referrals</div>
                          <Table>
                            <thead>
                              <th>First Name</th>
                              <th>Last Name</th>
                              <th>Creation Date</th>
                              <th>Current Status</th>
                              <th>Transactions</th>
                            </thead>

                          </Table>

                        </TabPane>


                        <TabPane tabId="11">
                           <div className="mb-20 h4 card-title w-100" style={{float:"left"}}>
                                                    Collection
                          
                                                     <RsAdNew to="#" onClick={ this.toggleAddCollection } className="btn btn-light btn-md float-end"  iconClass="">Add New</RsAdNew>{" "}
                                                  </div>
                                                  <div className="clearfix"></div>
                          <div className="table-responsive">
                            <Formik
                              initialValues={{

                                agentId: parseInt(localStorage.getItem('userId')),
                                campaignEmailListId: 0,
                                firstName: contactDetail.firstName,
                                lastName: contactDetail.lastName,
                                emailAddress: contactDetail.email,
                                contactNumber: contactDetail.mobile,
                                clientId: 0,
                                leadId: 0,
                                contactId: parseInt(contactDetail.id),
                                isUnsubscribed: false,
                                isActive: true,
                                checkedItems: []

                              }}
                              validationSchema={Yup.object().shape({
                                campaignEmailListId: Yup.array().min(1, 'Please select at least one collection')
                              })}
                            //onSubmit={this.handleSubmit}
                            >
                              {({ values, errors, touched, handleChange, handleBlur, setFieldValue }) => (
                                <Form className="needs-validation">
                                  <table className="table table-bordered border-primary align-middle table-nowrap mb-0">
                                    <thead>
                                      <tr>
                                        <th className="align-middle">
                                          <div className="form-check font-size-16 align-middle"></div>
                                        </th>
                                        <th className="align-middle">Name</th>
                                        <th className="align-middle">Description</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {campaignemaillists?.map((campaignemaillist, index) => {

                                        const isChecked = () => {
                                          return camplists?.some(
                                            (item) =>
                                              item.campaignEmailListId === campaignemaillist.id &&
                                              !item.isUnsubscribed &&
                                              item.contactId === contactDetail.id
                                          );
                                        };


                                        return (
                                          <tr key={index}>
                                            <td>
                                              <div className="form-check font-size-16 align-middle">
                                                <input
                                                  name={`campaignEmailListItem_${campaignemaillist.id}`}
                                                  type="checkbox"
                                                  checked={isChecked()}
                                                  onChange={() => {
                                                    const obj = JSON.parse(localStorage.getItem("authUser"));
                                                    const token = obj?.resultData?.bearerToken;
                                                    const str = `Bearer ${token}`;
                                                    const currentlyChecked = isChecked();
                                                    
                                                    const camplistItem = camplists?.find(
                                                      (item) =>
                                                        item.campaignEmailListId === campaignemaillist.id &&
                                                        item.contactId === contactDetail.id
                                                    );
                                                    const id = camplistItem ? camplistItem.id : 0;
                                                    const campaignEmailListItemId = camplistItem ? camplistItem.campaignEmailListItemId : "3fa85f64-5717-4562-b3fc-2c963f66afa6";
                                                    const requestPayload = {
                                                      id,
                                                      campaignEmailListItemId,
                                                      campaignEmailListId: campaignemaillist.id,
                                                      agentId: parseInt(values.agentId),
                                                      emailAddress: contactDetail.email,
                                                      firstName: contactDetail.firstName,
                                                      lastName: contactDetail.lastName,
                                                      contactNumber: contactDetail.mobile,
                                                      clientId: 0,
                                                      contactId: parseInt(contactDetail.id),
                                                      leadId: 0,
                                                      isUnsubscribed: currentlyChecked,
                                                      isActive: true,
                                                    };
                                                    const apiUrl = `${API_URL}CampaignEmailListItem`;
                                                    const method = camplistItem ? "put" : "post";
                                                    axios({
                                                      method,
                                                      url: apiUrl,
                                                      data: requestPayload,
                                                      headers: {
                                                        "Content-Type": "application/json",
                                                        Authorization: str,
                                                      },
                                                    })
                                                      .then((response) => {
                                                        
                                                        onGetCampContactList(localStorage.getItem('userId'), contactDetail.id)
                                                      })
                                                      .catch((error) => {
                                                        console.error('Error during API call:', error);
                                                      });
                                                  }}
                                                  className="form-check-input"
                                                  id={`campaignEmailListItem_${campaignemaillist.id}`}
                                                />
                                                <label
                                                  htmlFor={`campaign_${campaignemaillist.id}`}
                                                  className="form-check-label"
                                                >
                                                  &nbsp;
                                                </label>
                                                {touched.campaignEmailListId && errors.campaignEmailListId ? (
                                                  <div className="invalid-feedback d-block">
                                                    {errors.campaignEmailListId}
                                                  </div>
                                                ) : null}
                                              </div>
                                            </td>
                                            <td>{campaignemaillist.campaignEmailListName}</td>
                                            <td>{campaignemaillist.campaignEmailListDesc}</td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>

                                  {touched.campaignEmailListId && errors.campaignEmailListId ? (
                                    <div className="text-danger mt-2">{errors.campaignEmailListId}</div>
                                  ) : null}
                                  {/* <SaveButton>Submit</SaveButton> */}
                                </Form>

                              )}
                            </Formik>
                          </div>
                        </TabPane>


                      </TabContent>
                    </Card>
                  </Col>
                </Row>

              </Col>
            </Row>



          </Container>
        </div>

        <Offcanvas
          isOpen={this.state.isRightEdit}
          direction="end"
          toggle={this.toggleRightCanvasEdit}
          style={{ width: 800 }}
        >
          <OffcanvasHeader toggle={this.toggleRightCanvasEdit}>
            Update Contact
          </OffcanvasHeader>
          <OffcanvasBody>
            <ContactEdit />

          </OffcanvasBody>
        </Offcanvas>
    <Offcanvas
                              isOpen={this.state.isAddCollection}
                              direction="end"
                              toggle={this.toggleAddCollection}
                            >
                              <OffcanvasHeader toggle={this.toggleAddCollection}>
                                Add New
                              </OffcanvasHeader>
                              <OffcanvasBody>
                              <Formik
                                            enableReinitialize={true}
                                            initialValues={{
                                                campaignEmailListName: '',
                                                emailListTypeId: 1,
                                                emailListTargetId: '',
                                                campaignEmailListDesc: '',
                                                agentId: parseInt(localStorage.getItem('userId'))
                                            }}
                                            validationSchema={Yup.object().shape({
                                                //emailListTypeId: Yup.string().required("This is required"),
                                                emailListTargetId: Yup.string().required("This is required"),
                                                campaignEmailListName: Yup.string().required("This is required"),
                                            })}
        
                                            onSubmit={this.handleProTypeSubmit}
                                        >
                                            {({ errors, touched, values, handleChange, setFieldValue }) => (
                                                <Form
                                                    className="needs-validation"
                                                >
                                                    <Row>
        
                                                    {/* <Col sm="12">
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor="emailListTypeId">
                                                            {this.props.t("List Type")}
                                                            </Label>
                                                            <SafeField as="select" name="emailListTypeId" 
                                                            className={
                                                            "form-control" +
                                                            (errors.emailListTypeId && touched.emailListTypeId
                                                                ? " is-invalid"
                                                                : "")
                                                            }
                                                            
                                                            onChange={handleChange}>
                                                                <option value="">Select</option>
                                                                {map(emaillisttypes, (emaillisttype, classkey) => (
                                                                    <option value={emaillisttype.id} key={classkey}>{emaillisttype.emailListTypeTitle}</option>
                                                                ))}
                                                            </SafeField>
                                                            <ErrorMessage
                                                            name="emailListTypeId"
                                                            component="div"
                                                            className="invalid-feedback"
                                                            />
                                                        </FormGroup>
                                                        </Col> */}
                                                        <Col sm="12">
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor="emailListTargetId">
                                                            {this.props.t("List Target *")}
                                                            </Label>
                                                            <SafeField as="select" name="emailListTargetId" 
                                                            className={
                                                            "form-control" +
                                                            (errors.emailListTargetId && touched.emailListTargetId
                                                                ? " is-invalid"
                                                                : "")
                                                            }
                                                            
                                                            onChange={handleChange}>
                                                                <option value="">Select</option>
                                                                {map(emaillisttargets, (emaillisttarget, classkey) => (
                                                                    <option value={emaillisttarget.id} key={classkey}>{emaillisttarget.emailListTargetTitle}</option>
                                                                ))}
                                                            </SafeField>
                                                            <ErrorMessage
                                                            name="emailListTargetId"
                                                            component="div"
                                                            className="invalid-feedback"
                                                            />
                                                        </FormGroup>
                                                        </Col>
                                                        <Col sm="12">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="campaignEmailListName">
                                                                    {this.props.t("Title *")}
                                                                </Label>
                                                                <SafeField
                                                                    name="campaignEmailListName"
                                                                    onChange={handleChange}
        
                                                                    type="text"
        
                                                                    className={
                                                                        "form-control" +
                                                                        (errors.campaignEmailListName && touched.campaignEmailListName
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }
        
                                                                    id="campaignEmailListName"
                                                                />
                                                                <ErrorMessage
                                                                    name="campaignEmailListName"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>
        
                                                        </Col>
                                                        <Col sm="12">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="campaignEmailListDesc">
                                                                    {this.props.t("Description")}
                                                                </Label>
                                                                <SafeField
                                                                    name="campaignEmailListDesc"
                                                                    onChange={handleChange}
        
                                                                    type="text"
        
                                                                    className={
                                                                        "form-control" +
                                                                        (errors.campaignEmailListDesc && touched.campaignEmailListDesc
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }
        
                                                                    id="campaignEmailListDesc"
                                                                />
                                                                <ErrorMessage
                                                                    name="campaignEmailListDesc"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>
        
                                                        </Col>                
                                                        <Col sm="12">
                                                           <SaveButton>Save</SaveButton>
                                                        </Col>
        
                                                    </Row>
                                                </Form>
                                            )}
                                        </Formik>
        
                              </OffcanvasBody>
                 </Offcanvas>

                     {showCompose && (
                                                 <ComposeContactMail
                                                   agentData={userdetail}
                                                   contactDetail={contactDetail}
                                                   //onSend={this.handleSend}
                                                   onClose={() => this.setState({ showCompose: false })}
                                                 />
                                               )}
      </React.Fragment>
    )
  }
}
ContactDetail.propTypes = {
  error: PropTypes.any,
  t: PropTypes.any,
  match: PropTypes.object,
  onGetContactDetail: PropTypes.object,
  history: PropTypes.object,
  onGetAllContactAct: PropTypes.func,
  contactDetail: PropTypes.object,
  allactivities: PropTypes.array,
  campaignemaillists: PropTypes.array,
  onGetCampaignEmailList: PropTypes.func,
  onGetCampContactList: PropTypes.func,
  camplists: PropTypes.array,
  onGetEmailListTarget: PropTypes.func,
  emaillisttargets: PropTypes.array,
  addCampaignEmailList:PropTypes.func,
  userdetail:PropTypes.object,
  isResponsive:PropTypes.object

}

const mapStateToProps = ({ AppoinmentObject, contact }) => (
  //,
  {
    contactDetail: contact.contactDetail,
    allactivities:contact.allactivities,
    appDetails: contact.appDetails,
    campaignemaillists: AppoinmentObject.campaignemaillists,
    camplists: contact.camplists,
     emaillisttargets: AppoinmentObject.emaillisttargets,


  })

const mapDispatchToProps = dispatch => ({
  onGetContactDetail: id => dispatch(getContactDetail(id)),
  onGetAllContactAct: id => dispatch(getAllContactActivityTab(id)),
  onGetCampaignEmailList: (agentId) => dispatch(getCampaignEmailList(agentId)),
  onGetCampContactList: (agentId, contactId) => dispatch(getCampContactList(agentId, contactId)),
   onGetEmailListTarget: (agentId) => dispatch(getEmailListTarget(agentId)),
  onGetCampLeadList:(agentId, LeadId) => dispatch(getCampLeadList(agentId, LeadId)),
  addCampaignEmailList: (data,callback) => dispatch(addCampaignEmailList(data,callback))

});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ContactDetail))
